import { render, staticRenderFns } from "./WidgetType.vue?vue&type=template&id=e441b490&scoped=true"
import script from "./WidgetType.vue?vue&type=script&lang=js"
export * from "./WidgetType.vue?vue&type=script&lang=js"
import style0 from "./WidgetType.vue?vue&type=style&index=0&id=e441b490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e441b490",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
